import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsNotEmpty,
  IsOptional,
  IsUUID,
} from 'class-validator'

export class ResourceLinkDto {
  @ApiProperty({
    description: 'ID du lien ressource',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: 'ID de la ressource',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  resourceId!: string

  @ApiPropertyOptional({
    description: 'ID du chapitre lié',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({
    description: 'ID de la leçon liée',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  lessonId?: string
}
